<template>
  <div>
    <common-dialog
      ref="dialog"
      width="300px"
      show-save-button
      title="家长人脸"
      edit-title
      id-key="StudentId"
      :data="data"
      form-label-width="100px"
      :form-rules="rules"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      @closed="onClosed"
      :save-func="api.batchUpdateParentFace"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="开放家长人脸">
              <el-switch v-model="turnOn"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ParentFace: 0,
        Ids: [],
      },
      turnOn: false,
      api: require("@/api/st/student").default,
      isMB: this.$store.state.isMB,
      rules: {
        // Grade: [{ required: true, message: "请填写年级" }],
      },
    };
  },
  computed: {
    
  },
  methods: {
    onCreateOpened(data) {
      this.data.Ids = data.Ids;
    },
    onEditOpened(data) {
      
    },
    onBeforeSave() {
      this.data.ParentFace = this.turnOn?1:0;
    },
    onClosed() {
      this.turnOn = false;
    },
  },
};
</script>
<style lang="scss" scoped>

</style>